<main>
  <loading-overlay [isLoading]="isLoading()"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Inventory_Adjustments_Title' | translateWF: 'Inventory Adjustments' }}</h1>
        <div class="page__title_buttons">
          <p-splitButton label="New" icon="pi pi-plus" [model]="menuItems" (onClick)="createNew()"></p-splitButton>
        </div>
      </div>
    </div>
    <!-- Results Table -->
    <p-panel header="All Adjustments">
      <p-card data-variant="compact">
        <p-table
          [value]="adjustments"
          [loading]="isLoading()"
          [paginator]="true"
          [rows]="take"
          [totalRecords]="totalRecords"
          (onPage)="onPageChange($event)"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} adjustments"
          [rowsPerPageOptions]="[10, 25, 50]"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Number</th>
              <th>Status</th>
              <th>Type</th>
              <th>Reason</th>
              <th># Lines</th>
              <th>Created Date</th>
              <th>Created By</th>
              <th>Actions</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-adjustment>
            <tr>
              <td>
                <span (click)="viewDetails(adjustment)">
                  {{ adjustment.number || '-' }}
                </span>
              </td>
              <td>
                <p-tag [value]="getStatusLabel(adjustment.status)" [severity]="getStatusSeverity(adjustment.status)"> </p-tag>
              </td>
              <td>{{ getTypeLabel(adjustment.type) }}</td>
              <td>{{ adjustment.reason || '-' }}</td>
              <td class="text-center">{{ adjustment.lines?.length || 0 }}</td>
              <td>{{ formatDate(adjustment.createdDate) }}</td>
              <td>{{ adjustment.createdBy || '-' }}</td>
              <td>
                <div class="row-sm">
                  <button pButton type="button" icon="pi pi-eye" class="p-button-sm p-button-info p-button-text" pTooltip="View Details" (click)="viewDetails(adjustment)"></button>
                  <button
                    *ngIf="canVoid(adjustment)"
                    pButton
                    type="button"
                    icon="pi pi-times"
                    class="p-button-sm p-button-danger p-button-text"
                    pTooltip="Void Adjustment"
                    (click)="voidAdjustment(adjustment)"
                  ></button>
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="8" class="text-center py-4">No inventory adjustments found</td>
            </tr>
          </ng-template>
        </p-table>
      </p-card>
    </p-panel>
  </div>
</main>
